import React from 'react';
import InputText from '../../../components/agv-forms-input';
import VehicleTypeRadio from '../components/vehicle-type-radio';
import VehicleColorPicker from '../components/vehicle-color-picker';
import useGetFactories from '../../../api/factories/useGetFactories';
import FieldTitle from '../../../components/agv-forms-title';

export default function VehicleGeneralInfoStep({ vehicleData, setVehicleData }) {
  const { factories, isLoading: isLoadingFactories } = useGetFactories();

  const handleChange = (field, value) => {
    setVehicleData({ ...vehicleData, [field]: value });
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-text-lg tw-font-semibold tw-mb-2">
        Informations générales du véhicule
      </div>

      <div className="tw-grid tw-grid-cols-2 tw-gap-4">
        <InputText
          fieldTitle="Numéro du camion (CAMION)"
          value={vehicleData.CAMION}
          setValue={(value) => handleChange('CAMION', value)}
          isRequired={true}
          placeholder="Ex: 123"
          type="number"
          emptyError="Ce champ est requis"
        />

        <InputText
          fieldTitle="Libellé du camion (LIBCAM)"
          value={vehicleData.LIBCAM}
          setValue={(value) => handleChange('LIBCAM', value)}
          isRequired={true}
          placeholder="Ex: Camion frigorifique"
          emptyError="Ce champ est requis"
        />

        <InputText
          fieldTitle="Immatriculation (IMMAT)"
          value={vehicleData.IMMAT}
          setValue={(value) => handleChange('IMMAT', value)}
          isRequired={true}
          placeholder="Ex: AA-123-BB"
          emptyError="Ce champ est requis"
        />

        <InputText
          fieldTitle="Téléphone du camion (TELCAM)"
          value={vehicleData.TELCAM}
          setValue={(value) => handleChange('TELCAM', value)}
          isRequired={true}
          placeholder="Ex: 0612345678"
          emptyError="Ce champ est requis"
        />

        <InputText
          fieldTitle="Transporteur (TRANSP)"
          value={vehicleData.TRANSP}
          setValue={(value) => handleChange('TRANSP', value)}
          isRequired={true}
          placeholder="Ex: Transport SA"
          emptyError="Ce champ est requis"
        />

        <div className="tw-flex tw-flex-col">
          <FieldTitle title="Site de rattachement" isRequired={false} />
          <select
            className="tw-mt-1 tw-block tw-w-full tw-rounded-md tw-border-gray-300 tw-shadow-sm focus:tw-border-primary focus:tw-ring-primary tw-px-3 tw-py-2"
            value={vehicleData.factory_id || ''}
            onChange={(e) => handleChange('factory_id', e.target.value)}
            disabled={isLoadingFactories}
          >
            <option value="">Aucun site sélectionné</option>
            {Array.isArray(factories) && factories.map((factory) => (
              <option key={factory.id} value={factory.id}>
                {factory.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="tw-mt-4">
        <VehicleTypeRadio
          fieldTitle="Type de véhicule"
          value={vehicleData.LIBTYP}
          setValue={(value) => handleChange('LIBTYP', value)}
          isRequired={true}
        />
      </div>

      <div className="tw-mt-4">
        <VehicleColorPicker
          fieldTitle="Couleur du véhicule"
          value={vehicleData.color}
          setValue={(value) => handleChange('color', value)}
          isRequired={false}
        />
      </div>
    </div>
  );
}

